theme.headerSticky = (function() {   
  function ScrollSticky(e){     
    const headerStickyWrapper = document.querySelector('.header__area');     
    const headerStickyTarget = document.querySelector('.header__sticky');          

    if(headerStickyTarget){       
      let headerHeight = headerStickyWrapper.clientHeight;
      
      // Create a placeholder element to maintain space when header becomes fixed
      const placeholder = document.createElement('div');
      placeholder.style.height = headerHeight + 'px';
      placeholder.style.display = 'none';
      placeholder.classList.add('header-sticky-placeholder');
      
      // Insert placeholder right after the header
      headerStickyWrapper.parentNode.insertBefore(placeholder, headerStickyWrapper.nextSibling);
      
      window.addEventListener('scroll', function(){         
        let StickyTargetElement = TopOffset(headerStickyWrapper);         
        let TargetElementTopOffset = StickyTargetElement.top;         
        
        if(window.scrollY > headerHeight ){           
          headerStickyTarget.classList.add('sticky');
          // Show placeholder to maintain space
          placeholder.style.display = 'block';
        } else {           
          headerStickyTarget.classList.remove('sticky');
          // Hide placeholder when header is in normal position
          placeholder.style.display = 'none';
        }       
      })     
    }             
  }   
  return ScrollSticky; 
})();